/*(function ($) {
	// Scroll Event
	$(window).on('scroll', function () {
		var windowTop = $(window).scrollTop(),
    	windowWidth = $(window).width(),
        header = $('#header'),
        navContainer = $('#main-nav-container'),

        navContainerHeight = navContainer.height(),
        navDist = navContainer.offset().top,
        headerHeight = (header.height() - navContainerHeight);

	    if (windowTop >= navDist && windowTop > headerHeight && windowWidth > 768) {
	    	$(".cart-button-2").addClass('ledisplay-menu');
	    } else {
	    	$(".cart-button-2").removeClass('ledisplay-menu');
	    }

	});

})(jQuery);*/



// WEBPACK FOOTER //
// ./www/assets/lib/old/custom-script.js